var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockBoxes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 484.185 484.185",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.267,
    y: 37.448,
    style: {
      fill: "#ffffff"
    },
    width: 39.931,
    height: 59.896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.989,
    y: 237.101,
    style: {
      fill: "#ffffff"
    },
    width: 39.931,
    height: 59.896
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "232.111,77.379 232.111,157.24 92.353,157.24 92.353,37.448 142.267,37.448 142.267,97.344 182.197,97.344 182.197,37.448 232.111,37.448 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "391.833,237.101 391.833,356.893 252.076,356.893 252.076,277.032 252.076,237.101 301.989,237.101 301.989,296.997 341.919,296.997 341.919,237.101 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.111,
    y: 77.379,
    style: {
      fill: "#ffffff"
    },
    width: 149.74,
    height: 79.861
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.336,
    y: 277.032,
    style: {
      fill: "#ffffff"
    },
    width: 149.74,
    height: 79.861
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "436.755,157.24 436.755,187.188 42.44,187.188 42.44,157.24 92.353,157.24 232.111,157.24 381.851,157.24 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "436.755,356.893 436.755,386.841 42.44,386.841 42.44,356.893 102.336,356.893 252.076,356.893 391.833,356.893 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "42.44,386.841 42.44,476.685 7.501,476.685 7.501,7.5 42.44,7.5 42.44,157.24 42.44,187.188 42.44,356.893 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "476.685,7.5 476.685,476.685 436.755,476.685 436.755,386.841 436.755,356.893 436.755,187.188 436.755,157.24 436.755,7.5 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.255,0v149.74h-39.904V69.878h-149.74v-39.93H84.854V149.74H49.94V0H0.001v484.185h49.938v-89.844h379.315v89.844 h54.931V0H429.255z M239.611,84.878h134.74v64.861h-134.74V84.878z M149.767,44.948h24.931v44.896h-24.931V44.948z M99.854,44.948h34.913v59.896h54.931V44.948h34.913V149.74H99.854V44.948z M429.255,164.74v14.948H49.94V164.74H429.255z M244.576,229.601v39.931H94.836v79.861H49.94V194.688h379.315v154.705h-29.922V229.601H244.576z M259.576,244.601h34.913v59.896 h54.931v-59.896h34.913v104.792H259.576V244.601z M309.49,289.497v-44.896h24.931v44.896H309.49z M244.576,284.532v64.861 h-134.74v-64.861H244.576z M34.94,469.185H15.001V15h19.938L34.94,469.185L34.94,469.185z M49.94,379.341v-14.948h379.315v14.948 H49.94z M469.185,469.185h-24.931V15h24.931V469.185z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.945,
    y: 109.809,
    width: 29.948,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.049,
    y: 109.809,
    width: 49.913,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.171,
    y: 309.462,
    width: 29.948,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.275,
    y: 309.462,
    width: 49.913,
    height: 15
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockBoxes);
export default __webpack_public_path__ + "static/media/stock-boxes.8f0b562c9c29ecb51fd339b6eb2379f2.svg";
export { ForwardRef as ReactComponent };